module.exports = __webpack_public_path__ + "img/ptz-icon6.5faf8a5e.svg";